import { endOfMonth, startOfMonth } from 'date-fns'
import { useMemo } from 'react'

import { mainColors, SMedium } from '@avantstay/backoffice-core'

import * as S from '../DatePicker.styles'
import { ViewComponentProps } from '../DatePicker.types'
import { buildAutoScrollableRef, getMonthViewPresets } from '../DatePicker.utils'

export const MonthView = ({ value, preset, onChange }: ViewComponentProps) => {
  const monthViewPresets = useMemo(() => getMonthViewPresets(), [])

  const handleSelectPreset = ({
    newPreset,
    month,
    year,
  }: {
    newPreset: string
    month: number
    year: number
  }) => {
    const referenceDate = new Date(year, month)
    onChange({
      value: { startDate: startOfMonth(referenceDate), endDate: endOfMonth(referenceDate) },
      metadata: { preset: newPreset },
    })
  }

  return monthViewPresets.map(({ year, presets }) => (
    <div
      key={`month-view-${year}`}
      ref={buildAutoScrollableRef({ presetYear: year, startDate: value?.startDate })}
    >
      <SMedium color={mainColors.neutralExtraDark}>{year}</SMedium>

      <S.ViewGrid>
        {presets.map((monthViewPreset, index) => (
          <S.ViewPresetButton
            key={`month-view-${year}-preset-${monthViewPreset}`}
            aria-selected={value?.startDate?.getFullYear() === year && monthViewPreset === preset}
            onClick={() => handleSelectPreset({ newPreset: monthViewPreset, month: index, year })}
          >
            {monthViewPreset}
          </S.ViewPresetButton>
        ))}
      </S.ViewGrid>
    </div>
  ))
}
